// import React, { useRef, useState, useEffect } from "react";
// import calendarImage from "../images/calendar_month.svg";

// // Utility function to format the date to "YYYY-MM-DD"
// const formatDate = (date) => {
//   if (!date) return "";
//   const d = new Date(date);
//   const year = d.getFullYear();
//   const month = String(d.getMonth() + 1).padStart(2, "0");
//   const day = String(d.getDate()).padStart(2, "0");
//   return `${year}-${month}-${day}`;
// };

// const DatePickerInput = ({
//   selectedDate,
//   minDate,
//   maxDate,
//   onChange,
//   props,
//   disable,
// }) => {
//   const dateInputRef = useRef(null);
//   const [hasValue, setHasValue] = useState(!!selectedDate);

//   // Ensure input updates correctly if selectedDate changes externally
//   useEffect(() => {
//     setHasValue(!!selectedDate);
//   }, [selectedDate]);

//   const handleIconClick = () => {
//     if (dateInputRef.current) {
//       if (dateInputRef.current.showPicker) {
//         dateInputRef.current.showPicker(); // Modern browsers
//       } else {
//         dateInputRef.current.focus(); // Fallback for older browsers
//       }
//     }
//   };

//   const handleInputChange = (event) => {
//     const value = event.target.value;
//     setHasValue(!!value);
//     onChange(value); // Call the onChange prop to update Formik state
//   };

//   return (
//     <div className="custom_date_input position-relative custom-date-wrapper2">
//       <input
//         type="date"
//         placeholder="DD-MM-YYYY"
//         id="dob"
//         className={`form-control date_birth_input ${
//           hasValue ? "has-value" : ""
//         }`}
//         ref={dateInputRef}
//         value={formatDate(selectedDate)} // Ensure proper date format
//         onChange={handleInputChange}
//         min={minDate}
//         max={maxDate}
//         disabled={disable ? disable : false}
//       />
//       <span className="custom-placeholder2">DD-MM-YYYY</span>
//       <span
//         className="calendericon passwordicon"
//         onClick={() => {
//           if (!disable) {
//             handleIconClick();
//           }
//         }}
//         style={{ cursor: "pointer" }}
//       >
//         <img src={calendarImage} alt="Calendar Icon" />
//       </span>
//     </div>
//   );
// };

// export default DatePickerInput;

import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, parse, isValid } from "date-fns";
import calendarImage from "../images/calendar_month.svg";
import { ErrorMessage } from "formik";

const DatePickerInput = ({
  selectedDate,
  minDate,
  maxDate,
  onChange,
  disable = false,
  placeholder = "DD-MM-YYYY",
  name = "dob", // default field name
  label = "Date of Birth",
}) => {

  console.log("namenamename", name)
  // Convert stored dd-MM-yyyy string into Date object for DatePicker
  const parseToDate = (val) => {
    if (!val) return null;
    return parse(val, "dd-MM-yyyy", new Date());
  };

  const toDateObject = (val) => {
    if (!val) return null;

    // Case 1: Already a Date
    if (val instanceof Date) return isValid(val) ? val : null;

    // Case 2: ISO string (from DB or API)
    if (typeof val === "string" && val.includes("T")) {
      const d = new Date(val);
      return isValid(d) ? d : null;
    }

    // Case 3: dd-MM-yyyy string
    if (typeof val === "string") {
      const d = parse(val, "dd-MM-yyyy", new Date());
      return isValid(d) ? d : null;
    }
    return null;
  };

  return (
    <div className="form-group">
      <div className="input-group position-relative custom-date-wrapper">
        <DatePicker
          id={name}
          name={name}
          className="form-control"
          // selected={
          //   selectedDate
          //     ? (() => {
          //         const parsed = parse(selectedDate, "dd-MM-yyyy", new Date());
          //         return isValid(parsed) ? parsed : null; // only return if valid
          //       })()
          //     : null
          // }
          selected={toDateObject(selectedDate)}
          onChange={(date) => {
            if (date instanceof Date && isValid(date)) {
              onChange(format(date, "dd-MM-yyyy")); // send back string
            } else {
              onChange(""); // clear on invalid
            }
          }}
          dateFormat="dd-MM-yyyy"
          placeholderText={placeholder}
          minDate={minDate ? new Date(minDate) : null}
          maxDate={maxDate ? new Date(maxDate) : null}
          disabled={disable}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          portalId="root-portal"
        />

        <span
          className="passwordicon calendericon"
          style={{
            cursor: disable ? "not-allowed" : "pointer",
            position: "absolute",
            right: "10px",
            top: "100%",
            transform: "translateY(-10%)",
          }}
        >
          <img
            src={calendarImage}
            alt="calendar icon"
            onClick={() => {
              if (!disable) {
                document.getElementById(name).focus();
              }
            }}
          />
        </span>
      </div>

      {/* <ErrorMessage name={name} component="div" className="text-danger mt-1" /> */}
    </div>
  );
};

export default DatePickerInput;
